import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { cloneElement, useCallback, useMemo, useState } from 'react';
import { Checkmark, Copy } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { useBiAction } from '../BiTracking';
import { IconButton } from '../IconButton';
export const GetCopyButtonTID = (parentTestId)=>getTestIds(parentTestId);
export function CopyButton(param) {
    let { copyText, iconButtonProps, children, onSuccess, onFailure, bi, noBi: _noBi, testId } = param;
    const [showTick, setShowTick] = useState(false);
    const { CopyButtonTestIds } = useMemo(()=>GetCopyButtonTID(testId), [
        testId
    ]);
    const logBiAction = useBiAction();
    const doCopy = useCallback(async ()=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'copy_button',
                entityName: bi.name,
                actionType: 'click',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : ''
                })
            });
        }
        try {
            await window.navigator.clipboard.writeText(copyText);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            setShowTick(true);
            setTimeout(()=>setShowTick(false), 1000);
        } catch (e) {
            onFailure === null || onFailure === void 0 ? void 0 : onFailure(e);
        }
    }, [
        bi,
        logBiAction,
        copyText,
        onSuccess,
        onFailure,
        testId
    ]);
    return children ? /*#__PURE__*/ cloneElement(children, {
        onClick: doCopy
    }) : /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({
        onClick: doCopy
    }, iconButtonProps, testId != null ? {
        testId
    } : {}), {
        // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- CopyButton self-logs its own `click` BI event; inner IconButton bi would double-fire
        noBi: true,
        children: showTick ? /*#__PURE__*/ _jsx(Checkmark, {
            testId: CopyButtonTestIds.CopiedIcon()
        }) : /*#__PURE__*/ _jsx(Copy, {
            testId: CopyButtonTestIds.CopyIcon()
        })
    }));
}
